@if (!row) {
    <div class="empty-panel text-muted">Select a screening to review</div>
} @else {
    <div class="review-panel">
        <app-detail-info-card [title]="guestName" [data]="guestDetails"></app-detail-info-card>

        <mat-card appearance="outlined" class="card-container mt-3" data-test="autohost-review-card">
            <div class="d-flex flex-row align-items-center mt-3">
                <h2 class="header-title">Review</h2>
            </div>
            @if (loading) {
                <div class="d-flex flex-column align-items-center py-4" data-test="reasons-loading">
                    <mat-spinner diameter="32"></mat-spinner>
                    <span class="text-muted mt-2">Loading AutoHost review…</span>
                </div>
            } @else if (error === 'not-found') {
                <p class="text-muted">No AutoHost data for this screening</p>
            } @else if (error === 'busy') {
                <p class="reasons-error">AutoHost is busy — try again in a minute.
                    <button mat-button data-test="retry-reasons" (click)="retry()">Retry</button></p>
            } @else if (error === 'failed') {
                <p class="reasons-error">Couldn't load review reasons from AutoHost.
                    <button mat-button data-test="retry-reasons" (click)="retry()">Retry</button></p>
            } @else if (reasons) {
                <div class="review-body">
                    @if (reasons.verificationStatusReason) {
                        <p class="status-reason">{{ reasons.verificationStatusReason }}</p>
                    }
                    @for (check of reasons.checks; track check.name) {
                        <div class="check">
                            <div class="check-name">{{ checkLabel(check.name) }}</div>
                            @if (check.help) {
                                <div class="check-help">{{ check.help }}</div>
                            }
                            @if (check.findings?.length) {
                                <ul class="check-findings">
                                    @for (finding of check.findings; track $index) {
                                        <li>{{ finding }}</li>
                                    }
                                </ul>
                            }
                        </div>
                    }
                    @if (reasons.topRisks?.length) {
                        <div class="collapsible-header top-concerns" (click)="topConcernsExpanded = !topConcernsExpanded">
                            <span class="item-key">Top concerns</span>
                            <mat-icon>{{ topConcernsExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                        </div>
                        @if (topConcernsExpanded) {
                            <ul class="check-findings">
                                @for (risk of reasons.topRisks; track $index) {
                                    <li>{{ risk }}</li>
                                }
                            </ul>
                        }
                    }
                </div>
            }

            <div class="actions mt-4 mb-3">
                @if (queue === queues.NEEDS_REVIEW) {
                    <button mat-raised-button class="action-button me-2" data-test="mark-as-passed"
                        [disabled]="pendingAction" (click)="markAsPassed.emit(row)">
                        @if (pendingAction === 'pass') {
                            <mat-spinner diameter="18" class="button-spinner"></mat-spinner> Passing…
                        } @else {
                            Mark as Passed
                        }
                    </button>
                    <button mat-raised-button class="action-button" data-test="keep-as-consider"
                        [disabled]="pendingAction" (click)="keepAsConsider.emit(row)">
                        @if (pendingAction === 'keep') {
                            <mat-spinner diameter="18" class="button-spinner"></mat-spinner> Saving…
                        } @else {
                            Keep as Consider
                        }
                    </button>
                } @else {
                    <button mat-raised-button class="action-button" data-test="return-to-queue"
                        [disabled]="pendingAction" (click)="returnToQueue.emit(row)">
                        @if (pendingAction === 'return') {
                            <mat-spinner diameter="18" class="button-spinner"></mat-spinner> Returning…
                        } @else {
                            Return to Needs Review
                        }
                    </button>
                }
            </div>
            <div class="d-flex flex-wrap mb-3">
                @if (row.guestId) {
                    <a class="d-flex align-items-center go-to-guest-link" data-test="go-to-guest"
                        [routerLink]="['/guests/detail', row.guestId]" target="_blank">
                        <mat-icon class="go-to-guest-icon">people</mat-icon>
                        Go to Guest details
                    </a>
                }
            </div>
        </mat-card>
    </div>
}
